import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
// Model
import { ArraySectionDirectiveModel } from '../../../../models/extended-section-options';
import { LayoutComponentBroadcast, LayoutRenderLayoutItem } from '../../../models/cv-layout-render.model';
import { BroadcastGeneralEventMetadata, GeneralEventType } from '../../models/component.events';
// Service
import { LayoutRenderService } from '../../../services/layout-render.service';

@Component({
	selector: 'cv-schema-render-section',
	templateUrl: './section.component.html',
	styleUrls: ['./section.component.scss']
})
export class SectionComponent implements OnInit, OnDestroy {
	@Input() item: any = {}; // need model
	@Input() layoutNode = new LayoutRenderLayoutItem();

	sectionData = null;
	directiveData = new ArraySectionDirectiveModel();

	protected atComponentDestroy = new Subject();

	constructor(private layoutService: LayoutRenderService) {
		this.layoutService.componentBroadcast
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((broadcastData: LayoutComponentBroadcast) => {
				if (broadcastData.jsonPath === this.sectionData._Path) {
					if ('section' in broadcastData) {
						if (broadcastData.section === this.directiveData.section) {
							this.processEventData(broadcastData);
						}
					} else {
						this.processEventData(broadcastData);
					}


				}
			});
	}

	ngOnInit(): void {
		this.sectionData = this.item.data;
		this.directiveData.indexes = this.sectionData._Data.index;
		this.directiveData.cssClass = `${this.sectionData._Data.section}-${this.sectionData._Data.index.join('-')}`;
		this.directiveData.section = this.sectionData._Data.section;
		this.directiveData.visible = true;

		// If the element has metadata
		if (this.sectionData._Data && this.sectionData._Data.metadata) {
			this.directiveData.metadata = this.sectionData._Data.metadata;
		}
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}

	/**
	 * Refactor function to process any eventData
	 *
	 * @param broadcastData @see LayoutComponentBroadcast
	 */
	private processEventData(broadcastData: LayoutComponentBroadcast): void {
		switch (broadcastData.eventType) {
			case GeneralEventType.UPDATE_DATA:
				const metaData: BroadcastGeneralEventMetadata = broadcastData.metaData || null;

				if (metaData && (metaData.isCreate || metaData.isReplace)) {
					const relativePath = metaData.path.replace(broadcastData.jsonPath, '');
					let dataPointer = this.getDataPointer(relativePath, this.item.data);

					if (metaData.isCreate) {
						dataPointer.push(metaData.data);
					}

					if (metaData.isReplace) {
						if (dataPointer === null) {
							dataPointer = this.getDataPointerViaPath(relativePath, this.item.data);
						}
						this.dataReplace(dataPointer, metaData.data);
					}
				}

				this.layoutService.componentBroadcast.next({
					eventType: GeneralEventType.DATA_UPDATED,
					jsonPath: this.sectionData._Path,
					metaData: broadcastData.metaData
				});

				break;
		}
	}

	/**
	 * Get the data given a string data pointer
	 *
	 * @param path
	 * @param data
	 * @returns
	 */
	private getDataPointer(path: string, data: any): any {
		if (path[0] === '.') {
			path = path.replace('.', '');
		}

		const pathArray = path.split('.');
		const thisPath = pathArray[0];
		let dataFound = data[path] || data;
		if (pathArray.length > 1) {
			const newPath = pathArray.slice(1).join('.');
			return this.getDataPointer(newPath, data[thisPath]);
		}

		const check = new RegExp(/\[(\d+)\]/, 'g');
		if (check.test(thisPath)) {
			const newString = thisPath.replace(check, '');
			dataFound = data[newString];

			const arrayIndex = [];
			let match = check.exec(thisPath);
			while (match) {
				arrayIndex.push(match[1]);
				match = check.exec(thisPath);
			}

			dataFound = dataFound[arrayIndex[0]] || null;
		}

		return dataFound;
	}

	/**
	 *
	 * @param path
	 * @param data
	 * @returns
	 */
	private getDataPointerViaPath(path: string, data: any): any {
		if (path[0] === '.') {
			path = path.replace('.', '');
		}

		const pathArray = path.split('.');
		const thisPath = pathArray[0];
		let dataFound = data[path] || data;

		const check = new RegExp(/\[(\d+)\]/, 'g');
		if (check.test(thisPath)) {
			const newString = thisPath.replace(check, '');
			dataFound = data[newString];

			dataFound = dataFound.find(item => (item._Path || '').includes(thisPath));
		}

		return dataFound;
	}

	/**
	 * Replace the data given another dataSet
	 */
	private dataReplace(data: any, newData: any): void {
		if ('[object Array]' === Object.prototype.toString.apply(newData)) {
			while (data.length) {
				data.splice(0, 1);
			}

			(newData || []).forEach(value => {
				data.push(value);
			})
		}

		if (!Array.isArray(newData) && typeof newData === 'object') {
			for (const key in newData) {
				data[key] = newData[key];
			}
		}

	}
}
